import { ErrorHandler, Injectable } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { environment } from "../environments/environment";

@Injectable()
export class SentrySingletonErrorHandler implements ErrorHandler {
  private dialogOpen = false;

  handleError(error: any): void {
    Sentry.captureException(error);
    if (! this.dialogOpen && environment.sentryUserFeedback) {
      this.dialogOpen = true;
      Sentry.showReportDialog({
        onClose: () => (this.dialogOpen = false),
      });
    }
  }
}